import { React, useEffect, useState } from "react"
import Element from "./Element";
import { VerticalTimeline }  from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';
import styles from 'react-responsive-carousel/lib/styles/carousel.min.css';

export default function Home() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const response = await fetch(`https://www.feuerwehr-werneck.de/wp-json/ffw/v1/geschichte`);
        if (!response.ok) {
          throw new Error(
            `This is an HTTP error: The status is ${response.status}`
          );
        }
        let actualData = await response.json();
        setData(actualData);
        setError(null);
      } catch(err) {
        setError(err.message);
        setData(null);
      } finally {
        setLoading(false);
      }  
    }
      getData()
    }, 
  []);

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (loading) {
    return <div>Loading...</div>;
  } else {
    return(
      <VerticalTimeline>
        {data.map(function(d, index){
          return <Element key={index} header={d.header} content={d.content} title={d.title} images={d.images} ></Element>
        })}
      </VerticalTimeline>);
    }

}
